import { AsyncState, DeriveAsyncStateArgs } from './types';

/**
 * Единственное место в проекте, где решается, что показать: индикатор, ошибку,
 * «пусто» или сами данные.
 *
 * Главное правило: **`isFetching` сам по себе никогда не переключает ветку рендера.**
 * Если показывать есть что — ветка остаётся `ready`, а факт запроса уезжает в
 * `isRefreshing`. Именно поэтому список не схлопывается на каждом нажатии клавиши в
 * поиске, и именно из-за отсутствия этого разделения страница выбора организатора
 * осталась вообще без индикатора (IMGM-1408).
 *
 * Порядок проверок значим:
 *
 * 1. есть что показать → `ready` (ошибка при непустых данных уходит в тост, данные не стираем);
 * 2. чего-то ждём → `loading`;
 * 3. ошибка и показать нечего → `error`;
 * 4. ответ пришёл и он пуст → `empty`;
 * 5. иначе запрос ещё не стартовал (`skip`) → тоже `loading`, а не «пусто».
 */
export function deriveAsyncState({
  itemsCount,
  hasCurrentData,
  isFetching,
  isPending,
  isError,
}: DeriveAsyncStateArgs): AsyncState {
  const isWaiting = isFetching || Boolean(isPending);

  if (itemsCount > 0) {
    return { status: 'ready', isRefreshing: isWaiting || !hasCurrentData };
  }

  if (isWaiting) {
    return { status: 'loading', isRefreshing: false };
  }

  if (isError) {
    return { status: 'error', isRefreshing: false };
  }

  return { status: hasCurrentData ? 'empty' : 'loading', isRefreshing: false };
}
